// Saber se o backend caiu — e nao se a chamada deu erro.
//
// Todo deploy reinicia o backend e ele fica ~12s fora do ar. Nesses segundos o
// nginx devolve 502 para tudo, e quem clicou Enviar perdia a mensagem: o campo
// ja tinha sido limpo e o texto nao voltava. Medido em 22/09/2026: 3.314 POST e
// 694 PATCH derrubados em ~25 janelas de deploy num unico dia.
//
// Distinguir "o servidor esta fora" de "a chamada falhou" importa porque so o
// primeiro caso pode ser reenviado sozinho sem risco: se o backend nunca
// respondeu ao INSERT, nada foi gravado e repetir nao duplica nada.
//
// Nao adivinhamos pelo texto do erro (o postgrest-js embrulha 502 de formas
// diferentes) — perguntamos ao /health, que o nginx serve na raiz da API e que
// so responde quando o processo esta de pe.

const ORIGEM_API = String(
  import.meta.env.VITE_SUPABASE_URL ?? 'https://beta.crm-api.primetecia.com.br/api',
).replace(/\/api\/?$/, '');

const TIMEOUT_MS = 4000;
const INTERVALO_MS = 2000;
const TETO_MS = 120_000;

export async function servidorEstaFora(): Promise<boolean> {
  const ctrl = new AbortController();
  const t = setTimeout(() => ctrl.abort(), TIMEOUT_MS);
  try {
    const r = await fetch(`${ORIGEM_API}/health`, { cache: 'no-store', signal: ctrl.signal });
    return !r.ok;
  } catch {
    return true;
  } finally {
    clearTimeout(t);
  }
}

// Espera o backend voltar. Devolve true se voltou dentro do teto.
// O teto existe para o caso nao ser deploy: sem internet, esperar para sempre
// deixaria a mensagem presa sem ninguem avisar o consultor.
export async function esperarServidorVoltar(tetoMs: number = TETO_MS): Promise<boolean> {
  const limite = Date.now() + tetoMs;
  while (Date.now() < limite) {
    await new Promise((r) => setTimeout(r, INTERVALO_MS));
    if (!(await servidorEstaFora())) return true;
  }
  return false;
}
